export default __webpack_public_path__ + "static/media/chair-ecofriendly.ddd2260f.png";